// extracted by mini-css-extract-plugin
export default {"tableHeadCell":"styles_tableHeadCell__SazYU","tableBodyCell":"styles_tableBodyCell__KcViJ","tableFooter":"styles_tableFooter__c5Pne"};